import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { urls } from "assets/url/urls";
import { LoginService } from '../../login/login.service';
import { Registration, RegistrationEntrance, RegistrationExit, RegistrationReport } from 'app/model/registration';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RegistrationRequestService {
  private readonly REST_API_SERVER_JSON = `${urls.baseUrl}/registrations`

  private readonly HEADERS = new HttpHeaders({
    'X-TENANT-ID': urls.tenant,
    'Authorization': 'Bearer ' + this.loginService.getToken()
  })

  /**
  * Constructor
  *
  * @param {HttpClient} http,
  * @param {LoginService} loginService
  */
  constructor(
    private http: HttpClient,
    private loginService: LoginService
  ) { }

  public getAllRegistrations(): Observable<Registration[]> {
    const headers = this.HEADERS

    return this.http.get<Registration[]>(`${this.REST_API_SERVER_JSON}`, { headers })
  }

  public getRegistrationsByDpto(dptoId: number): Observable<Registration[]> {
    const headers = this.HEADERS

    return this.http.get<Registration[]>(`${this.REST_API_SERVER_JSON}/department/${dptoId}`, { headers })
  }

  public getRegistrationsByEmployee(employeeId: number): Observable<Registration[]> {
    const headers = this.HEADERS

    return this.http.get<Registration[]>(`${this.REST_API_SERVER_JSON}/employee/${employeeId}`, { headers })
  }

  public checkIfEmployeeHasCheckedInToday(): Observable<Registration[]> {
    const user = this.loginService.getUser()

    const headers = this.HEADERS

    return this.http.get<Registration[]>(`${this.REST_API_SERVER_JSON}/today/${user.employee.id}`, { headers })
  }

  public startRegistration(registration: RegistrationEntrance): Observable<RegistrationEntrance> {
    const headers = this.HEADERS

    return this.http.post<RegistrationEntrance>(`${this.REST_API_SERVER_JSON}`, registration, { headers })
  }

  public finallyRegistration(registrationId: number, registration: RegistrationExit): Observable<Registration> {
    const headers = this.HEADERS

    return this.http.put<Registration>(`${this.REST_API_SERVER_JSON}/${registrationId}`, registration, { headers })
  }

  public finallyLastRegistration(employeeId: number): Observable<Registration> {
    const headers = this.HEADERS

    return this.http.put<Registration>(`${this.REST_API_SERVER_JSON}/today/${employeeId}`, {}, { headers })
  }

  public generateReport(registrationReports: RegistrationReport[]): Observable<Blob> {
    const headers = this.HEADERS

    return this.http.post(`${this.REST_API_SERVER_JSON}/generate-report`, registrationReports, { headers, responseType: 'blob' })
  }
}